import React from "react";
import BreadcrumbsHeader from "../components/breadcrumbs/BreadcrumbsHeader";

const PrivacyPolicy = () => {
  return (
    <div className="page-container" id="missionidd">
      {/* Breadcrumbs Header */}

         <BreadcrumbsHeader 
        title="Privacy Policy" 
        backgroundImage="/images/header/about-isols.jpg" 
      />


    
      {/* Privacy Policy Section */}
      <section className="section-about">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-12 wow slideInLeft">
              <div className="b-services-item">
                <div className="services-text">
                  <h2 className="termm">Your Privacy Matters: Our Privacy Policy</h2>
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    OVERVIEW
                  </h6>
                  <p>
                    The below privacy policy is application on the main domain www.isolsgroup.com
                    and all its sub-domains such as store.isolsgroup.com that is ISOLS’s online shop.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 1 - WHAT DO WE DO WITH YOUR INFORMATION?
                  </h6>
                  <p>
                    When you browse our website or Android or iOS Mobile Application, we also automatically receive your computer’s internet protocol (IP) address in order to provide us with information that helps us learn about your browser and operating system. Email marketing or Newsletter (if applicable): With your permission, we may send you emails about our website or Android or iOS Mobile Application or products or services & solutions or other updates. SMS & WhatsApps marketing (if applicable): With your permission, we may send you sms & WhatsApp about our website or Android or iOS Mobile Application and other updates.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 2 - CONSENT
                  </h6>
                  <p><strong>How do you get my consent?</strong></p>
                  <p>
                    When you provide us with personal information to complete a transaction or at the time of making an enquiry or while purchasing any product/services from ISOLS online shop, verify your credit card, place an order, we imply that you consent to our collecting it and using it for that specific reason or for the marketing or promotional alert purpose.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 3 - DISCLOSURE
                  </h6>
                  <p>
                    We may disclose your personal information if we are required by law to do so or if you violate our Terms of Service.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 4 - THIRD-PARTY SERVICES
                  </h6>
                  <p>
                    In general, the third-party providers used by us will only collect, use and disclose your information to the extent necessary to allow them to perform the services they provide to us. However, certain third-party service providers, such as payment gateways and other payment transaction processors, have their own privacy policies in respect to the information we are required to provide to them for your purchase-related transactions. For these providers, we recommend that you read their privacy policies so you can understand the manner in which your personal information will be handled by these providers.
                  </p>
                  <p><strong>Links</strong></p>
                  <p>
                    When you click on links on our website or Android or iOS Mobile Application, they may direct you away from our website or Android or iOS Mobile Application. We are not responsible for the privacy practices of other sites and encourage you to read their privacy statements.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 5 - SECURITY
                  </h6>
                  <p>
                    To protect your personal information, we take reasonable precautions and follow industry best practices to make sure it is not inappropriately lost, misused, accessed, disclosed, altered or destroyed.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 6 - COOKIES
                  </h6>
                  <p>
                    We use cookies to maintain session of your user. It is not used to personally identify you on other websites.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 7 - AGE OF CONSENT
                  </h6>
                  <p>
                    By using this site, you represent that you are at least the age of majority in your state or province of residence, or that you are the age of majority in your state or province of residence and you have given us your consent to allow any of your minor dependents to use this site.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 8 - CHANGES TO THIS PRIVACY POLICY
                  </h6>
                  <p>
                    We reserve the right to modify this privacy policy at any time, so please review it frequently. Changes and clarifications will take effect immediately upon their posting on the website. If we make material changes to this policy, we will notify you here that it has been updated, so that you are aware of what information we collect, how we use it, and under what circumstances, if any, we use and/or disclose it.
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    SECTION 9 - TERMS & CONDITIONS
                  </h6>
                  <p>
                    For Terms and Conditions Please visit our Terms and Conditions section establishing the use, disclaimers, and limitations of liability governing the use of our website at <a href="https://www.isolsgroup.com" target="_blank" rel="noopener noreferrer">https://www.isolsgroup.com</a>
                  </p>
                </div>

                <div className="services-text">
                  <h6 className="services-title customColor customPseudoElBg font-secondary text-uppercase">
                    QUESTIONS AND CONTACT INFORMATION
                  </h6>
                  <p>
                    If you would like to: access, correct, amend or delete any personal information we have about you, register a complaint, or simply want more information contact our Privacy Compliance at legal@isolsgroup.com.
                  </p>
                </div>

                <div className="services-text">
                  <p><b>Last Updated on 10th July, 2021</b></p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
